import { ProjectManagementHttpClient } from './httpClient';

const url = 'userValidation/search';

const getUserSearchServiceConfig = () => {
  return {
    timeoutSeconds: process.env.SEARCH_USER_API_SEARCH_TIMEOUT_IN_SECONDS || 30,
  };
};

export const userSearchService = (role, maxResultCount, territory) => {
  let userSearchServiceCancelToken;

  return async (searchText) => {
    if (typeof userSearchServiceCancelToken !== typeof undefined) {
      userSearchServiceCancelToken.cancel('tokenCanceled');
    }

    const config = getUserSearchServiceConfig();
    const resultsFromServer = await ProjectManagementHttpClient().get(
      url,
      {
        searchText,
        role,
        maxResultCount,
        territory,
        timeoutSeconds: config.timeoutSeconds,
      },
      false,
      (cancelToken) => {
        userSearchServiceCancelToken = cancelToken;
      }
    );

    return resultsFromServer.data;
  };
};
